import { useListContext } from 'framework/list';
import { TimelineContextData } from 'framework/ui/timeline';
import { useShowContext } from 'framework/show';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { SxProps } from '@mui/material';
import { PinTimelineButton } from 'domain/shared/timeline';

interface UseEmployeeTimelinePinActionProps {
  isPinned: boolean;
  key: string;
  sx?: SxProps;
}

const useEmployeeTimelinePinAction = ({
  isPinned,
  key,
  sx = { fontSize: '18px' },
}: UseEmployeeTimelinePinActionProps) => {
  const employeeId = useEmployeeId() || '';
  const { data } = useShowContext();
  const timelineId = data?.getValueBySource('timelineId');
  const { updateInList, pinTimelineAction }: TimelineContextData = useListContext();

  if (!pinTimelineAction || !timelineId) {
    return [];
  }

  return [
    <PinTimelineButton
      key={key}
      pinStatus={!!isPinned}
      sx={sx}
      pinMethod={async () => {
        const response = await pinTimelineAction(employeeId, timelineId, !isPinned);

        if (response) {
          updateInList?.(response.id, response);
        }
      }}
    />,
  ];
};

export default useEmployeeTimelinePinAction;
